export enum TopicType {
    QUESTION = "QUESTION",
    DEFERMENT_OF_PAYMENT = "DEFERMENT_OF_PAYMENT",
    QUESTION_ABOUT_PAYMENTS = "QUESTION_ABOUT_PAYMENTS",
    DEBT_LINEUP = "DEBT_LINEUP",
    INSOLVENCY_PROCEEDINGS = "INSOLVENCY_PROCEEDINGS",
    RATE_AGREEMENT = "RATE_AGREEMENT",
    RATE_AGREEMENT_QUESTION_WITHOUT_FEATURE = "RATE_AGREEMENT_QUESTION_WITHOUT_FEATURE",
    ORDER_DOCUMENTS = "ORDER_DOCUMENTS",
    COMPLAINT = "COMPLAINT",
    COMPLAINT_BAFIN = "COMPLAINT_BAFIN",
    DEBT_COUNSELLING = "DEBT_COUNSELLING",
}
